import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

export default function LinearDeterminate({value}) {

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress
  sx={{
    backgroundColor:"#EAEBEF",
    "& .MuiLinearProgress-bar": {
      background: "linear-gradient(269.97deg, #87DBCA -2.3%, #0FB694 30.39%, #87DBCA 70.03%, #0090C1 118.56%)"
    }
  }}
    variant="determinate" 
    value={value} />
    </Box>
  );
}